export default {
  // Ready chains from the baseline health endpoint, normalized for the selector.
  chains: [],
  chainsLoading: false,
  chainsLoaded: false,
  // Overall health payload status ('ready' | 'degraded' | ...), kept for debugging
  // only — it is never surfaced (RULE-5.2 keeps coverage internals internal).
  // Every chain the service knows, health notwithstanding — the history filter
  // needs to reach rows written by a chain that is momentarily down. Fetched
  // once, on demand, and never polled: `chains` above is the live one.
  allChains: [],
  allChainsLoading: false,
  allChainsLoaded: false,
  healthStatus: null,
  healthError: null,
  // Set only by the PDF entry, from the credentials the generator was called
  // with. In the browser this stays null and the session bearer is used.
  apiKey: null,
}
